import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vuelidate from 'vuelidate';
import Paginate from 'vuejs-paginate';
import ToggleButton from 'vue-js-toggle-button';
import moment from 'moment';
import Snotify, {SnotifyPosition} from 'vue-snotify';
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

import interceptorsSetup from './helpers/interceptor';

const options = {
    toast: {
        position: SnotifyPosition.rightTop,
        timeout: 4000,
        showProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true
    }
};

interceptorsSetup();
Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.component('paginate', Paginate);
Vue.use(ToggleButton);
Vue.prototype.moment = moment;
Vue.use(Snotify, options);
Vue.use(Tooltip);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
